import React from 'react';
import './ConfirmationModal.css';

/**
 * A reusable confirmation modal component
 * @param {Object} props - Component props
 * @param {string} props.title - The modal title
 * @param {string} props.message - The confirmation message
 * @param {string} props.confirmButtonText - Text for the confirm button
 * @param {string} props.cancelButtonText - Text for the cancel button
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {boolean} props.isLoading - Whether the confirm action is processing
 * @param {function} props.onConfirm - Function to call when confirm is clicked
 * @param {function} props.onCancel - Function to call when cancel is clicked
 */
const ConfirmationModal = ({
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  isOpen,
  isLoading = false,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirmation-modal-overlay" onClick={isLoading ? null : onCancel}>
      <div className="confirmation-modal" onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <p>{message}</p>

        <div className="confirmation-buttons">
          <button
            className="confirm-button-cancel"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelButtonText}
          </button>

          <button
            className="confirm-button-confirm"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="processing-spinner"></span>
                Processing...
              </>
            ) : (
              confirmButtonText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 